import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackCloseFilter = ({ element, context, filterLvl, filtersValue, length, campaignId, }) => {
    const closeFilter = {
        context: context || getGA4Context(),
        element,
        filter_lvl: filterLvl === 0 ? 0 : filterLvl || null,
        filters_value: filtersValue,
        length: length || null,
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-close_filter', {
        event_name: 'close_filter',
        close_filter: closeFilter,
    });
};
